namespace Matrix.Data {
    export interface SecurityMatchRulesetForm {
        RulesetCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        SecurityMatchRuleList: SecurityMatchRulesetRuleEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMatchRulesetForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMatchRuleset';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMatchRulesetForm.init)  {
                SecurityMatchRulesetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = SecurityMatchRulesetRuleEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SecurityMatchRulesetForm, [
                    'RulesetCode', w0,
                    'Description', w0,
                    'SecurityMatchRuleList', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
